/**
 * The API docs' captured example responses aren't fully self-consistent —
 * e.g. the real POST /auth/register response shown uses "uuid" and a
 * singular "role" array, while the generic schema block elsewhere in the
 * same doc shows "id" and plural "roles". Rather than gamble on which one
 * ships, normalize both shapes into the field names the rest of this app
 * already relies on (full_name, roles, must_change_password, ...).
 */
export function normalizeUser(raw) {
  if (!raw) return null;

  const firstName = raw.first_name ?? '';
  const lastName = raw.last_name ?? '';
  const fullName = [firstName, lastName].filter(Boolean).join(' ') || raw.full_name || raw.email;

  return {
    id: raw.id ?? raw.uuid,
    first_name: firstName,
    last_name: lastName,
    full_name: fullName,
    email: raw.email,
    phone: raw.phone ?? null,
    roles: raw.roles ?? raw.role ?? [],
    must_change_password: !!raw.must_change_password,
    email_verified_at: raw.email_verified_at ?? null,
    suspended_at: raw.suspended_at ?? null,
    // Drives investor-side KYC gating (pending_approval / active / rejected
    // — see pages/investor/KycForm.jsx). Not previously captured since
    // nothing needed it yet; passed through defensively rather than
    // guessed at, since the current-user endpoint is the only place this
    // could plausibly live (no dedicated "my KYC status" endpoint exists).
    account_status: raw.account_status ?? null,
  };
}

export default normalizeUser;
